<script>
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { faIcons } from "../data/faIconList";

	import IconAutocomplete from "./IconAutocomplete.svelte";

	export let icon;
	export let handleChange = () => {};
	export let name = "new icon select";
	export let key = "";
	export let itemId;

	let iconName = icon?.name || "";

	const handleIconSelect = (e) => {
		if (!faIcons[iconName]) {
			icon = undefined;
			return;
		}

		icon = {
			name: iconName,
			icon: JSON.stringify(faIcons[iconName]),
		};

		handleChange(e);
	};

	$: options = Object.keys(faIcons).map((i) => ({
		value: i,
		option: {
			component: SvelteFa,
			props: { icon: faIcons[i], size: "2x" },
		},
	}));
</script>

<div class="flex gap-2 justify-start">
	{#if icon?.icon}
		<SvelteFa icon={JSON.parse(icon.icon)} size="3x" />
	{/if}
	<IconAutocomplete
		bind:value={iconName}
		{options}
		handleChange={handleIconSelect}
		{name}
		{key}
		{itemId}
	/>
</div>
